import logoImage from "../assets/images/bluecareplus-logo.svg";
import FormHeader from "../components/bcptn/FormHeader";
import {CLIENT_NAME, CLIENT_THEME} from "../utils/constants";
import APP_ENV from "../config/appEnv";
import { getFormFields } from '../components/bcptn/fields';

const config = {
    clientName: CLIENT_NAME.BCPT,
    isMultiLingual: true,
    isPlainButton: true,

    // theme
    theme: CLIENT_THEME.BCPT,

    // header
    logo: logoImage,
    logoWidth: 304,
    logoHeight: 73,
    logoLink: APP_ENV.CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'Member Experience Panel',
        customHeader: {
            enabled: true,
            component: FormHeader
        },
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },
        showReturn: true,
        showCancel: false,
    },

    // footer
    footer: {
        isAcceptedDate: true,
        meta: {
            materialId: 'H3259_25PHEACApp_C'
        },
        isLicenseInfo: true,
        copyright: `© BlueCare Plus Tennessee 2024. All rights reserved.`,
    },
    tracking: {
        phcall: "/?utm_source=phcall&utm_medium=phone&utm_campaign=recruit",
        phcalls: "/?utm_source=phcalls&utm_medium=phone&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        emails: "/?utm_source=emails&utm_medium=online&utm_campaign=recruit",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        mnews: "/?utm_source=mnews&utm_medium=online&utm_campaign=recruit",
        mnewss: "/?utm_source=mnewss&utm_medium=online&utm_campaign=recruit",
        hold: "/?utm_source=hold&utm_medium=phone&utm_campaign=recruit",
        lp: "/?utm_source=lp&utm_medium=online&utm_campaign=recruit",
        lps: "/?utm_source=lps&utm_medium=online&utm_campaign=recruit",
        cm: "/?utm_source=cm&utm_medium=phone&utm_campaign=recruit",
        cms: "/?utm_source=cms&utm_medium=phone&utm_campaign=recruit",
        pc: "/?utm_source=pc&utm_medium=online&utm_campaign=recruit",
    }
}

export default config;
